import "../../Home/Home.css";

function ModulesSection({
  modulesData,
  setSelectedModule,
  openAddModuleModal,
  userRole,
}) {
  const customStyles = {
    moduleEllipse: {
      backgroundColor: "#D3D3D3",
    },
    carouselInner: {
      justifyContent: "center",
    },
    espacamento: {
      height: "30px",
    },
  };
  return (
    <div>
      {userRole === "admin_global" && (
        <button className="add-module-button" onClick={openAddModuleModal}>
          Add Module
        </button>
      )}
      <div style={customStyles.espacamento}></div>
      {/* Contêiner do carrossel */}
      <div className="carouselOuter">
        <div className="carouselInner" style={customStyles.carouselInner}>
          {modulesData.length > 0 && (
            <div className="gridContainer">
              {modulesData
                .sort((a, b) => a.priority - b.priority)
                .map((module) => (
                  <div
                    key={module.id}
                    className={`homepage-card ${module.isActive ? "active" : "inactive"}`}
                    style={{ position: "relative" }}
                    onClick={() => setSelectedModule(module)}
                  >
                    <span style={{ position: "absolute", top: 15, right: 15 }}>
                      {module.priority}
                    </span>
                    {/* Ícone do módulo */}
                    <div className="icon-container">
                      <div
                        className="moduleEllipse"
                        style={customStyles.moduleEllipse}
                      >
                        {module.pageIconUrl.startsWith("http") ? (
                          <img
                            className="module-icon"
                            src={`${module.pageIconUrl}`}
                            style={{
                              width: "60%", // Ajusta a largura à elipse
                              height: "60%", // Ajusta a altura à elipse
                              objectFit: "contain", // Ajusta a proporção da imagem
                            }}
                            aria-label="Ícone do módulo" // Acessibilidade
                          ></img>
                        ) : (
                          <span style={{ color: "white", fontSize: 18 }}>
                            No Icon
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Nome do módulo */}
                    <div className="text-style-card-homepage">
                      {module.pageName}
                    </div>

                    {/* Descrição do módulo */}
                    <div className="description-homepage">
                      {module.description}
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModulesSection;
